import {combineEpics} from 'web-app/util/redux-observable';

import addInvoiceEpics from './add-invoice/epics';
import addInvoiceV2Epics from './add-invoice-v2/epics';
import addPaymentEpics from './add-payment-modal/epics';
import billPayerEpics from './bill-payer-modal/epics';
import voucherEpics from './voucher-modal/epics';
import editBillPayersEpics from './edit-bill-payers/epics';
import linkContactEpics from './link-contact-modal/epics';
import depositEpics from './deposit-modal/epics';
import eventEpics from './event-modal/epics';
import invoiceEpics from './invoice/epics';
import accountItemMoveEpic from './account-item-move/epics';
import diaperEpics from './diaper/epics';
import applyCreamEpics from './apply-cream/epics';
import recipientsEpics from './recipients-modal/epics';
import obsReviewEpics from './review-observation-modal/epics';
import sleepEpics from './sleep/epics';
import inquiryModalsEpics from './inquiry-modals/epics';
import exportCSVEpics from './export-csv-modal/epics';
import addClosingDayEpics from './add-closing-day-modal/epics';
import newMessageEpics from './new-conversation-modal/epics';
import organizationPersonProfileEpics from './organization-person-profile-modal/epics';
import changeEmailEpics from './change-email-modal/epics';
import vacationPlanEpics from './vacation-plan-modal/epics';
import childPickup from './child-pickup-modal/epics';
import signIn from './signin-modal/epics';
import signInGPS from './signin-modal-gps/epics';
import incidentReportModalEpics from './manage-report-modal/epics';
import checkinPincodesModalEpics from './checkin-pincodes/epics';
import mealSettingsModalEpics from './meal-settings-modal/epics';
import fileTaggingModalEpics from './file-tagging-modal/epics';
import observationEditorModalEpics from './observation-editor-modal/epics';

export default combineEpics(
    newMessageEpics,
    addClosingDayEpics,
    addPaymentEpics,
    billPayerEpics,
    voucherEpics,
    editBillPayersEpics,
    linkContactEpics,
    depositEpics,
    eventEpics,
    invoiceEpics,
    accountItemMoveEpic,
    diaperEpics,
    applyCreamEpics,
    recipientsEpics,
    obsReviewEpics,
    addInvoiceEpics,
    addInvoiceV2Epics,
    sleepEpics,
    inquiryModalsEpics,
    exportCSVEpics,
    organizationPersonProfileEpics,
    changeEmailEpics,
    vacationPlanEpics,
    childPickup,
    signIn,
    signInGPS,
    incidentReportModalEpics,
    checkinPincodesModalEpics,
    mealSettingsModalEpics,
    fileTaggingModalEpics,
    observationEditorModalEpics,
);
